import PropTypes from 'prop-types';
import ModalWrapper from "common/components/modules/modal-wrapper";
import { useSelector } from 'react-redux';
import { screenWidthSelector } from 'admin/state/modules/common/selectors';

const SfwWarningModal = ({
   onConfirm,
   onCloseModal,
   modalType,
   checkboxNextValue,
}) => {
   const screenWidth = useSelector(screenWidthSelector);

   const getModalState = () => {
      switch (true) {
         case 'this_photoset_is_sfw' === modalType && checkboxNextValue:
            return {
               description: `The system will automatically mark this photoset’s <span class='font-semibold'>Default thumbnail</span> and <span class='font-semibold'>all files</span> as SFW.`,
            }

         case 'this_video_is_sfw' === modalType && checkboxNextValue:
            return {
               description: `The system will automatically mark this video’s <span class='font-semibold'>Thumbnail & Preview</span> as SFW.`,
            }

         case 'this_recorded_stream_is_sfw' === modalType && checkboxNextValue:
            return {
               description: `The system will automatically mark this recorded stream’s <span class='font-semibold'>Thumbnail</span> as SFW.`,
            }

         case 'this_photoset_is_sfw' === modalType && !checkboxNextValue:
            return {
               description: `The system will automatically mark this photoset’s <span class='font-semibold'>Default thumbnail</span> and <span class='font-semibold'>all files</span> as NSFW.`,
               secondDescription: 'Are you 100% sure this content is NSFW?',
               buttonText: 'Yes, the content is NSFW',
               cancelText: 'No, revert to SFW',
            }

         case 'this_video_is_sfw' === modalType && !checkboxNextValue:
            return {
               description: `The system will automatically mark this video’s <span class='font-semibold'>Thumbnail & Preview</span> as NSFW.`,
               secondDescription: 'Are you 100% sure this content is NSFW?',
               buttonText: 'Yes, the content is NSFW',
               cancelText: 'No, revert to SFW',
            }

         case 'this_recorded_stream_is_sfw' === modalType && !checkboxNextValue:
            return {
               description: `The system will automatically mark this recorded stream’s <span class='font-semibold'>Thumbnail</span> as NSFW.`,
               secondDescription: 'Are you 100% sure this content is NSFW?',
               buttonText: 'Yes, the content is NSFW',
               cancelText: 'No, revert to SFW',
            }

         case 'check_sfw_settings' === modalType:
            return {
               title: 'Check SFW settings',
               description: 'After content changes, SFW settings are reset. Please check that the settings are correct.',
               secondDescription: '',
               buttonText: 'Ok',
               withoutCancelButton: true,
            }

         default:
            return {
               description: `Content incorrectly marked as "Safe for Work" (SFW) may result in account suspension or closure.`,
            }
      }
   }

   return (
      <ModalWrapper
         isMobile={ screenWidth <= 1024 }
         type='confirm'
         icon='warning'
         iconColor='warning'
         iconSize='2xl'
         title='Warning'
         secondDescription='Are you 100% sure this content is SFW?'
         descriptionLeading='leading-5'
         secondDescriptionClassName='leading-5 text-secondary mt-5'
         buttonClassName='mt-8 w-full'
         buttonText='Yes, the content is SFW'
         cancelButtonWrapperClassName='w-full'
         cancelText='No, revert to NSFW'
         action={ onConfirm }
         onCloseModal={ onCloseModal }
         { ...getModalState() }
      />
   )
}

SfwWarningModal.propTypes = {
   onConfirm: PropTypes.func,
   onCloseModal: PropTypes.func,
   modalType: PropTypes.string,
   checkboxNextValue: PropTypes.bool,
}

export default SfwWarningModal;
